<div
    style="width: 100%"
    [ngStyle]="{ height: screenHeight - 150 + 'px' }"
    id="reportContainer"
></div>
